import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { createPush, editPush, showPush } from '~/config/routes';
import List from './List';
import Edit from './Edit';
import Show from './Show';
import New from './New';
import { PushProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function Push() {
  return (
    <PushProvider>
      <Switch>
        <Route
          exact
          path={createPush.spec}
          render={(props) => (
            <>
              <Can I="new" a="Pushs">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="Pushs">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={editPush.spec}
          render={(props) => (
            <>
              <Can I="edit" a="Pushs">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="Pushs">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showPush.spec}
          render={(props) => (
            <>
              <Can I="show" a="Pushs">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="Pushs">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="list" a="Pushs">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="Pushs">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </PushProvider>
  );
}
export default Push;
